var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"used-car-item"},[_c('UsedCarListItem',{attrs:{"item":_vm.data}}),_c('UsedCarOrderInfo',{ref:"order",attrs:{"orderid":_vm.id},on:{"returnorder":_vm.getOrderInfo}}),_c('ItemTabs',{ref:"itemTabs"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }